module.exports = __webpack_public_path__ + "img/Sur.9734bf95.png";